export const LINK_TYPE = 'link';
